import Icon from '../components/Icon.vue'

Icon.register({
  'bread-slice': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M288 0c180 0 288 93.4 288 169.1 0 30.3-24.2 54.9-64 54.9v256c0 17.7-16.1 32-36 32h-376c-19.9 0-36-14.3-36-32v-256c-39.8 0-64-24.6-64-54.9 0-75.7 108-169.1 288-169.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bread-slice.js
// module id = 1119
// module chunks = 0